import { makeRequest } from "./api";

export const FetchBedroom = async () => {
  return makeRequest("/api/admin/bedroomCapacity/fetch");
};

export const UpdateBedroom = async (
  itemName,
  otherItemName,
  startValue,
  endValue
) => {
  return makeRequest("/api/admin/bedroomCapacity/update", {
    method: "PUT",
    data: {
      itemName,
      otherItemName,
      startValue,
      endValue,
    },
  });
};
